export const fr = {
  operator: {
    dialogLabel: 'Paramètres de session',
    eyebrow: 'MODE OPÉRATEUR',
    title: 'Paramètres de session',
    close: 'Fermer',
    language: 'Langue',
    languageBilingual: 'Français + العربية',
    languageFrench: 'Français',
    languageArabic: 'العربية',
    questionCount: 'Questions par session',
    shuffleQuestions: 'Ordre aléatoire',
    shuffleAnswers: 'Mélanger les réponses',
    autoAdvance: 'Passage automatique',
    feedbackDuration: 'Durée du feedback (secondes)',
    restartDuration: 'Redémarrage final (secondes)',
    reset: 'Réinitialiser',
    apply: 'Appliquer',
    resetShortcut: 'Raccourci de réinitialisation immédiate : Ctrl + Shift + X',
  },
  control: {
    title: 'Contrôle à distance',
    subtitle: 'Appuyez sur une réponse pour l’envoyer à l’écran',
    connected: 'Connecté à l’écran',
    connecting: 'Connexion en cours…',
    disconnected: 'Déconnecté, vérifiez le réseau',
    error: 'Erreur de connexion',
    unconfigured: 'Configuration Pusher manquante (.env)',
    sent: 'Envoyé',
    start: 'Démarrer la session',
    reset: 'Réinitialiser la session',
    resetConfirm: 'Réinitialiser la session sur l’écran principal ?',
  },
} as const;
